import React, { useEffect, useState, useRef } from "react";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Row, Col } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import logo from "../../assets/Navbar/logo-white.png";
import logowhite from "../../assets/Navbar/logo-white.png";
import "./Header.css";

function Header() {
  
  const [sidebaropen, setSidebaropen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const sidebarRef = useRef(null);
  const location = useLocation();

  const toggleSidebar = () => {
    setSidebaropen(!sidebaropen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setSidebaropen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > window.innerHeight / 2);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (location.hash) {
      const target = document.querySelector(location.hash);
      if (target) {
        target.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  const handleLinkClick = () => {
    setSidebaropen(false); 
  };

  return (
    <>
      <Navbar
        className={`nav px-md-5 px-2 py-0 fixed-top navbar bg-body ${
          scrolled ? "scrolled" : "bg-transparent"
        }`}
      >
        <Navbar.Collapse
          id="responsive-navbar-nav"
          className="d-flex align-items-center justify-content-center"
        >
          <Nav className="mx-auto">
            <Nav.Link href="#" className="link p-0">
              <div className={`logo-container ${scrolled ? "logo-scrolled" : ""}`}>
                <Link to="/" rel="preload">
                  <img src={logowhite} alt="logo" className="logo" />
                </Link>
              </div>
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
        <div className="navmenubtn">
          <div className="d-flex gap-2 text-white" onClick={toggleSidebar}>
            <i className="ri-menu-4-line"></i>
            {/* <span>Menu</span> */}
          </div>
        </div>
      </Navbar>

      <div
        ref={sidebarRef}
        className={`navsidebar ${sidebaropen ? "open" : ""}`}
      >
        <Row className="g-0">
          <Col lg={7} className="navmenu-box">
            <Row className="h-100 g-0">
              <Col sm={12} className="navbarlist p-md-5 p-3">
                <button className="navclose-btn" onClick={toggleSidebar}>
                  <div className="d-flex gap-2">
                    <i className="ri-close-line text-white fw-thin"></i>
                    <p className="text-white">Close</p>
                  </div>
                </button>
                <ul className="navmenu">
                  <li className="navlink">
                    <Link
                      to="/discover"
                      onClick={() => handleLinkClick()}
                      className="nav-anchor"
                    >
                      Discover
                    </Link>
                  </li>
                  {/* <li className="navlink">
                    <Link
                      to="/activities"
                      onClick={() => handleLinkClick()}
                      className="nav-anchor"
                    >
                      Activities
                    </Link>
                  </li> */}
                  <li className="navlink">
                    <Link
                      to="/residences"
                      onClick={() => handleLinkClick()}
                      className="nav-anchor"
                    >
                      Residences
                    </Link>
                  </li>

                  <li className="navlink">
                    <Link
                      to="/Allprograms"
                      onClick={() => handleLinkClick()}
                      className="nav-anchor"
                    >
                      Programs
                    </Link>
                  </li>

                  
                  <li className="navlink">
                    <Link
                      to="/food"
                      onClick={() => handleLinkClick()}
                      className="nav-anchor"
                    >
                      Food Menu
                    </Link>
                  </li>
                  <li className="navlink">
                    <Link
                      to="/gallery"
                      onClick={() => handleLinkClick()}
                      className="nav-anchor"
                    >
                      Gallery
                    </Link>
                  </li>
                 
                  <li className="navlink">
                    <Link
                      to="/contact"
                      onClick={() => handleLinkClick()}
                      className="nav-anchor"
                    >
                      Contact
                    </Link>
                  </li>
                </ul>
              </Col>
            </Row>
          </Col>
          <Col lg={5} className="sidebar-address p-3 p-md-5">
            <div className="d-flex flex-column align-items-center justify-content-center h-100">
              <div className="pb-5">
                <img src={logo} alt="logo" className="logo" loading="lazy"/>
              </div>
              <div className="pb-4 text-center text-white">
                <span className="location-name">Location</span>
                <p>
                  Pagerewadi Khavne, Vengurla Sindhudurg,
                  <br />
                  Maharashtra, 416522
                </p>
              </div>
              <div className="pb-4 text-center text-white">
                <span className="location-name">Connect With Us</span>
                <p>+91-74839-18840</p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Header;
